module.exports = __webpack_public_path__ + "media/images/category-materials-23b148dcc70d34b592c5974b6ce97edd.jpg";